// client/src/services/importProfileService.js

import authService from './authService';

const apiUrl = process.env.REACT_APP_API_URL || '/api';

const authHeaders = (extra = {}) => ({
  ...extra,
  Authorization: `Bearer ${authService.getToken()}`
});

const checkUnauthorized = (response) => {
  if (response.status === 401) authService.handleUnauthorized();
};

const getProfiles = async () => {
  const response = await fetch(`${apiUrl}/import-profiles`, { headers: authHeaders() });
  checkUnauthorized(response);
  if (!response.ok) throw new Error('Erreur lors du chargement des profils.');
  return await response.json();
};

const createProfile = async (data) => {
  const response = await fetch(`${apiUrl}/import-profiles`, {
    method: 'POST',
    headers: authHeaders({ 'Content-Type': 'application/json' }),
    body: JSON.stringify(data)
  });
  checkUnauthorized(response);
  const result = await response.json();
  if (!response.ok) throw new Error(result.message || 'Erreur lors de la sauvegarde du profil.');
  return result;
};

const deleteProfile = async (id) => {
  const response = await fetch(`${apiUrl}/import-profiles/${id}`, {
    method: 'DELETE',
    headers: authHeaders()
  });
  checkUnauthorized(response);
  if (!response.ok) {
    const result = await response.json().catch(() => ({}));
    throw new Error(result.message || 'Erreur lors de la suppression du profil.');
  }
  return true;
};

const importProfileService = {
  getProfiles,
  createProfile,
  deleteProfile
};

export default importProfileService;
